import React from "react";

const ImageCard = ({ imageSrc, altText, caption }) => {
  return (
    <div
      style={{
        margin: "20px",
        textAlign: "center",
        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
        borderRadius: "8px",
        overflow: "hidden",
        backgroundColor: "#ffffff",
        maxWidth: "300px",
      }}
    >
      <img
        src={imageSrc}
        alt={altText}
        style={{ width: "100%", height: "auto" }}
      />
      <div style={{ padding: "10px" }}>
        <p style={{ fontSize: "1rem", color: "#004d66" }}>{caption}</p>
      </div>
    </div>
  );
};

export default ImageCard;